import { useEffect, useState } from 'react';
import { HQ } from './sportConfig';

const cached = () => { try { return JSON.parse(localStorage.getItem('sports-hq-push-state') || 'null'); } catch { return null; } };
export function isProtectedMatch(match) {
  if (!HQ.capabilities.notifications) return false;
  const key = HQ.sport === 'floorball' ? `floorball:innebandy:${match.id}` : `hockey:${match.simulation}:${match.match_id}`;
  return Boolean(cached()?.preferences?.sports?.[HQ.sport]?.matches?.some(row => row.id === key && row.watch_later));
}
export function usePushProtection() {
  const [, refresh] = useState(0);
  useEffect(() => {
    const update = () => refresh(value => value + 1);
    window.addEventListener('sports-hq-push-state', update);
    return () => window.removeEventListener('sports-hq-push-state', update);
  }, []);
}
export function currentMatchProtected() {
  if (!HQ.capabilities.notifications) return false;
  if (new URLSearchParams(location.search).get('push_protected') === '1') return true;
  const url = new URLSearchParams(location.search).get('url') || '';
  const id = url.match(/\/match\/(\d+)/)?.[1];
  const hockey = url.match(/^hq:\/\/hockey\/([^/]+)\/([^/]+)/);
  const key = HQ.sport === 'floorball' ? `floorball:innebandy:${id}` : hockey ? `hockey:${hockey[1]}:${hockey[2]}` : '';
  return Boolean(cached()?.preferences?.sports?.[HQ.sport]?.matches?.some(row => row.id === key && row.watch_later));
}
